import React from 'react';
import StockIndicator from '@hpstellar/core/StockIndicator';

import InventoryMessage from './inventory-message';

const ProductStatusBadge = ({ product, displayShipMessage, defaultMessage, defaultStatus, ...otherProps }) => {
    let msg = defaultMessage;
    let status = defaultStatus;
    return (
        <InventoryMessage product={product} showOOS={true}>
            {
                ({ stock, shippingMsg }) => {
                    if (stock === undefined || stock > 25) {
                        msg = ` In Stock`;
                        status = 'green';
                    } else if (stock <= 10 && stock > 0) {
                        msg = `Only ${stock} Left!`;
                        status = 'orange';
                        if (stock <= 5) {
                            status = 'red'
                        }
                    } else if (stock === 0) {
                        msg = 'Currently out of stock';
                        status = 'grey';
                    }
                    if (msg) {
                        return <StockIndicator
                            color={status}
                            stockMessage={msg}
                            deliveryMessage={displayShipMessage && shippingMsg}
                            {...otherProps}
                        />
                    }
                    return null;
                }
            }
        </InventoryMessage>
    )
}

export default ProductStatusBadge;